module.exports = __webpack_public_path__ + "img/flat-eprice-button-lincoln.3c905951.png";